import React, { useEffect } from "react";
import SubVisual from "../../components/SubVisual";
import subVisualOrganization from "../../assets/subVisual/subVisualOrganization.png";
import organizationImg from "../../assets/images/organization/organizationImg-new.webp";
import instagramIcon from "../../assets/images/common/instagram.png";
import * as S from "./styled";
import { organizationLists } from "../../data/organization";
import { NavLink } from "react-router-dom";
import Aos from "aos";
import { Helmet } from "react-helmet-async";

const Organization = () => {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const isReactSnap = navigator.userAgent === "ReactSnap";

    if (!isReactSnap) {
      Aos.init();
      window.scrollTo(0, 0);
    } else {
      window.scrollTo(0, document.body.scrollHeight);
    }
  }, []);
  return (
    <>
      <Helmet>
        <title>IPDIA 국제실용댄스지도자협회</title>

        <meta
          name="description"
          content="전문 댄스강사 양성 및 실용무용 교육과 네트워크를 선도하는 국제실용댄스지도자협회입니다."
        />

        <meta
          name="keywords"
          content="IPDIA, 아이피디아, 국제실용댄스지도자협회, 국제실용댄스, 셔플댄스, 댄스협회, 댄스자격증, 실용무용, 댄스강사자격증"
        />

        <meta property="og:title" content="넵튠 댄스 스튜디오" />
        <meta
          property="og:description"
          content="전문 댄스강사 양성 및 실용무용 교육과 네트워크를 선도하는 국제실용댄스지도자협회입니다."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="http://ipdiakorea.com" />
        <meta
          property="og:image"
          content="http://ipdiakorea.com/og-image.png"
        />
      </Helmet>
      <S.OrganizationContainer>
        <SubVisual
          src={subVisualOrganization}
          title="협회 조직도"
          subTitle="협회 소개"
        />
        <S.OrganizationWrapper>
          <S.OrganizationImgWrapper>
            <div className="inner">
              <img
                src={organizationImg}
                alt="sub visual"
                data-aos="fade-up"
                data-aos-duration={600}
                data-aos-easing="linear"
              />
            </div>
          </S.OrganizationImgWrapper>
          <S.OrganizationContentsWrapper>
            <div className="inner">
              <div
                className="title-wrap"
                data-aos="fade"
                data-aos-duration={600}
                data-aos-easing="linear"
              >
                강사진
              </div>
              <ul className="organization-ul">
                {organizationLists.map((item, index) => (
                  <li
                    data-aos="fade-up"
                    data-aos-duration={600}
                    data-aos-delay={(index + 1) * 200}
                    data-aos-easing="linear"
                  >
                    <div className="img-wrap">
                      <img src={item.img} alt="organization" />
                    </div>
                    <div className="text-wrap">
                      <div className="title">
                        <p>{item.name}</p>
                        <NavLink to={item.instagram} target="_blank">
                          <img src={instagramIcon} alt="instagram" />
                        </NavLink>
                      </div>
                      <div className="sub-title">
                        {item.subTitle.map((sub) => (
                          <p>{sub}</p>
                        ))}
                      </div>
                      <ul>
                        {item.contents.map((content) => (
                          <li>{content}</li>
                        ))}
                      </ul>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </S.OrganizationContentsWrapper>
        </S.OrganizationWrapper>
      </S.OrganizationContainer>
    </>
  );
};

export default Organization;
